// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-kenya/calculator-kenya-homeloan/calculator-kenya-homeloan.component.scss
// module id = 719
// module chunks = 0